webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = bus;

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FirebaseApp__ = __webpack_require__(8);











var cardRepository = function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(cardRepository, _EventEmitter);

  function cardRepository() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, cardRepository);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (cardRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(cardRepository)).call(this));

    _this.ref = __WEBPACK_IMPORTED_MODULE_8_firebase__["database"]().ref('cards');
    _this.userRef = __WEBPACK_IMPORTED_MODULE_8_firebase__["database"]().ref('users');
    _this.stackRef = __WEBPACK_IMPORTED_MODULE_8_firebase__["database"]().ref('stacks');

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(cardRepository, [{
    key: "create",
    value: function create(_ref, onComplete) {
      var type = _ref.type,
          title = _ref.title,
          author = _ref.author,
          description = _ref.description,
          url = _ref.url,
          image = _ref.image,
          _ref$snippet = _ref.snippet,
          snippet = _ref$snippet === undefined ? '' : _ref$snippet,
          icon = _ref.icon,
          show = _ref.show,
          source = _ref.source,
          creator = _ref.creator,
          stack = _ref.stack,
          order = _ref.order,
          stackCount = _ref.stackCount,
          length = _ref.length,
          boundStack = _ref.boundStack;

      var that = this;
      this.ref.push({ type: type, title: title, author: author, description: description, url: url, image: image, snippet: snippet, icon: icon, show: show, source: source, creator: creator, length: length, boundStack: boundStack }, onComplete).then(function (card) {
        that.ref.child(card.key).update({ created: __WEBPACK_IMPORTED_MODULE_8_firebase__["database"].ServerValue.TIMESTAMP }, onComplete);

        that.userRef.child(creator + '/cards/' + card.key).set(true, onComplete);

        that.userRef.child(creator + '/cardCount').transaction(function (currentCount) {
          return currentCount + 1;
        });

        if (stack) {
          that.addStack(card, stack, order);
        }

        if (boundStack) {
          that.stackRef.child(boundStack + '/boundCard').set(card.key, onComplete);
        }
      });
    }
  }, {
    key: "update",
    value: function update(_ref2, onComplete) {
      var key = _ref2.key,
          _ref2$title = _ref2.title,
          title = _ref2$title === undefined ? '' : _ref2$title,
          _ref2$description = _ref2.description,
          description = _ref2$description === undefined ? '' : _ref2$description,
          _ref2$url = _ref2.url,
          url = _ref2$url === undefined ? '' : _ref2$url,
          _ref2$image = _ref2.image,
          image = _ref2$image === undefined ? '' : _ref2$image,
          _ref2$source = _ref2.source,
          source = _ref2$source === undefined ? '' : _ref2$source,
          _ref2$snippet = _ref2.snippet,
          snippet = _ref2$snippet === undefined ? '' : _ref2$snippet,
          show = _ref2.show;

      this.ref.child(key).update({ title: title, description: description, url: url, image: image, source: source, snippet: snippet, show: show }, onComplete);
    }
  }, {
    key: "remove",
    value: function remove(card, onComplete) {

      var that = this;

      if (card.stacks) {
        var stackKeys = card.stacks;
        for (var stackKey in stackKeys) {
          this.stackRef.child(stackKey).once("value", function (snapshot) {
            var stack = snapshot.val();
            stack.key = snapshot.key;
            that.removeStack(card, stack);
          });
        }
      }

      this.ref.child(card.key).remove(onComplete);

      this.userRef.child(card.creator + '/cards/' + card.key).remove(onComplete);

      this.userRef.child(card.creator + '/cardCount').transaction(function (currentCount) {
        return currentCount - 1;
      });
    }
  }, {
    key: "addStack",
    value: function addStack(card, stack, order, onComplete) {
      this.stackRef.child(stack.key + '/cards/' + card.key).set(true, onComplete);
      this.stackRef.child(stack.key + '/cards/' + card.key).set({ order: order }, onComplete);
      this.stackRef.child(stack.key + '/cardCount').transaction(function (currentCount) {
        return currentCount + 1;
      });

      this.ref.child(card.key + '/stacks/' + stack.key).set(true, onComplete);
      this.ref.child(card.key + '/stackCount').transaction(function (currentCount) {
        return currentCount + 1;
      });

      this.ref.child(stack.boundCard + '/length').transaction(function (currentCount) {
        return currentCount + 1;
      });
    }
  }, {
    key: "removeStack",
    value: function removeStack(_ref3, stack, onComplete) {
      var key = _ref3.key;

      var that = this;

      var stackUpdatedCount;

      var stackToRemoveRef = this.stackRef.child(stack.key);

      var cardToRemoveOrder;

      this.ref.child(key + '/stacks/' + stack.key).remove(onComplete);

      this.ref.child(key + '/stackCount').transaction(function (currentCount) {
        return currentCount - 1;
      });

      stackToRemoveRef.child('/cards/' + key + '/order/').once("value", function (snapshot) {

        cardToRemoveOrder = snapshot.val();

        stackToRemoveRef.child('/cards/' + key).remove(onComplete).then(function () {
          stackToRemoveRef.child('/cards/').once("value", function (snapshot) {

            if (snapshot.val()) {

              var remainingStacks = snapshot.val();
              stackUpdatedCount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(remainingStacks).length;

              stackToRemoveRef.child('/cardCount').set(stackUpdatedCount, onComplete);

              that.ref.child(stack.boundCard + '/length').set(stackUpdatedCount, onComplete);

              snapshot.forEach(function (remainingStack) {
                var stack = remainingStack.val();
                var key = remainingStack.key;

                if (stack.order > cardToRemoveOrder) {
                  stackToRemoveRef.child('/cards/' + key + '/order/').set(stack.order - 1, onComplete);
                }
              });
            } else {
              stackToRemoveRef.child('/cardCount').set(0, onComplete);

              that.ref.child(stack.boundCard + '/length').set(0, onComplete);
            }
          });
        });
      });
    }
  }, {
    key: "removeStackfromCards",
    value: function removeStackfromCards(_ref4, cardkeys, onComplete) {
      var key = _ref4.key;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {

        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(cardkeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cardkey = _step.value;

          this.ref.child(cardkey + '/stacks/' + key).remove(onComplete);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "attachFirebaseListeners",
    value: function attachFirebaseListeners() {
      this.ref.on('child_added', this.onAdded, this);
      this.ref.on('child_removed', this.onRemoved, this);
      this.ref.on('child_changed', this.onChanged, this);
    }
  }, {
    key: "detachFirebaseListeners",
    value: function detachFirebaseListeners() {
      this.ref.off('child_added', this.onAdded, this);
      this.ref.off('child_removed', this.onRemoved, this);
      this.ref.off('child_changed', this.onChanged, this);
      this.stackRef.off();
      this.userRef.off();
    }
  }, {
    key: "onAdded",
    value: function onAdded(snapshot) {
      var card = this.snapshotToCard(snapshot);

      this.emit('added', card);
    }
  }, {
    key: "onRemoved",
    value: function onRemoved(oldSnapshot) {
      var card = this.snapshotToCard(oldSnapshot);
      this.emit('removed', card);
    }
  }, {
    key: "onChanged",
    value: function onChanged(snapshot) {
      var card = this.snapshotToCard(snapshot);
      this.emit('changed', card);
    }
  }, {
    key: "snapshotToCard",
    value: function snapshotToCard(snapshot) {
      var key = snapshot.key;
      var card = snapshot.val();
      card.key = key;
      card.username = null;

      this.userRef.child(card.creator + '/username').on('value', function (snapshot) {
        card.username = snapshot.val();
      });

      return card;
    }
  }, {
    key: "findIndex",
    value: function findIndex(cards, key) {
      return cards.findIndex(function (card) {
        return card.key === key;
      });
    }
  }, {
    key: "find",
    value: function find(cards, key) {
      return cards.find(function (card) {
        return card.key === key;
      });
    }
  }]);

  return cardRepository;
}(__WEBPACK_IMPORTED_MODULE_7_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = new cardRepository();

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


var config = {
    apiKey: "AIzaSyC0UoBomQoBDKNqDLHadTDrnDLKYRDmbuo",
    authDomain: "learn-e4341.firebaseapp.com",
    databaseURL: "https://learn-e4341.firebaseio.com",
    storageBucket: "learn-e4341.appspot.com",
    messagingSenderId: "632068953078"
};
var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](config);
/* unused harmony default export */ var _unused_webpack_default_export = firebaseApp;

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FirebaseApp__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cardRepository__ = __webpack_require__(56);










var stackFunctions = function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(stackFunctions, _EventEmitter);

  function stackFunctions() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, stackFunctions);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (stackFunctions.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(stackFunctions)).call(this));

    _this.ref = __WEBPACK_IMPORTED_MODULE_6_firebase__["database"]().ref('stacks');
    _this.userRef = __WEBPACK_IMPORTED_MODULE_6_firebase__["database"]().ref('users');
    _this.cardRef = __WEBPACK_IMPORTED_MODULE_6_firebase__["database"]().ref('cards');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(stackFunctions, [{
    key: "create",
    value: function create(_ref, onComplete) {
      var _ref$title = _ref.title,
          title = _ref$title === undefined ? '' : _ref$title,
          _ref$description = _ref.description,
          description = _ref$description === undefined ? '' : _ref$description,
          _ref$slug = _ref.slug,
          slug = _ref$slug === undefined ? '' : _ref$slug,
          _ref$creator = _ref.creator,
          creator = _ref$creator === undefined ? '' : _ref$creator;

      var that = this;
      this.ref.push({ title: title, description: description, slug: slug, creator: creator }, onComplete).then(function (stack) {
        that.userRef.child(creator + '/stacks/' + stack.key).set(true, onComplete);
        that.ref.child(stack.key).update({ created: __WEBPACK_IMPORTED_MODULE_6_firebase__["database"].ServerValue.TIMESTAMP }, onComplete);
        that.userRef.child(creator + '/stackCount').transaction(function (currentCount) {
          return currentCount + 1;
        });

        __WEBPACK_IMPORTED_MODULE_8__cardRepository__["a" /* default */].create({
          title: title,
          description: description,
          url: "/stack/" + slug,
          creator: creator,
          author: creator,
          type: "stack",
          length: 0,
          image: null,
          source: 'stacks',
          snippet: description,
          icon: null,
          show: 'stack',
          stack: null,
          order: null,
          stackCount: null,
          boundStack: stack.key
        }, function (err) {
          if (err) {
            throw err;
          }
        });
      });
    }
  }, {
    key: "update",
    value: function update(_ref2, onComplete) {
      var boundCard = _ref2.boundCard,
          key = _ref2.key,
          _ref2$title = _ref2.title,
          title = _ref2$title === undefined ? '' : _ref2$title,
          _ref2$description = _ref2.description,
          description = _ref2$description === undefined ? '' : _ref2$description;

      this.ref.child(key).update({ title: title, description: description }, onComplete);
      this.cardRef.child(boundCard).update({ title: title, description: description }, onComplete);
    }
  }, {
    key: "remove",
    value: function remove(stack, onComplete) {
      var that = this;
      var card;

      if (stack.boundCard) {
        this.cardRef.child(stack.boundCard).once('value').then(function (snapshot) {
          card = snapshot.val();
          card.key = snapshot.key;
          __WEBPACK_IMPORTED_MODULE_8__cardRepository__["a" /* default */].remove(card, function (err) {

            if (err) throw err;
          });
          that.ref.child(stack.key).remove(onComplete);
        });
      } else {
        this.ref.child(stack.key).remove(onComplete);
      }

      this.userRef.child(stack.creator + '/stacks/' + stack.key).remove(onComplete);
      this.userRef.child(stack.creator + '/stackCount').transaction(function (currentCount) {
        return currentCount - 1;
      });
    }
  }, {
    key: "attachFirebaseListeners",
    value: function attachFirebaseListeners() {
      this.ref.on('child_added', this.onAdded, this);
      this.ref.on('child_removed', this.onRemoved, this);
      this.ref.on('child_changed', this.onChanged, this);
    }
  }, {
    key: "detachFirebaseListeners",
    value: function detachFirebaseListeners() {
      this.ref.off('child_added', this.onAdded, this);
      this.ref.off('child_removed', this.onRemoved, this);
      this.ref.off('child_changed', this.onChanged, this);
      this.userRef.off();
      this.cardRef.off();
    }
  }, {
    key: "onAdded",
    value: function onAdded(snapshot) {
      var stack = this.snapshotToStack(snapshot);

      this.emit('added', stack);
    }
  }, {
    key: "onChanged",
    value: function onChanged(snapshot) {
      var stack = this.snapshotToStack(snapshot);
      this.emit('changed', stack);
    }
  }, {
    key: "onRemoved",
    value: function onRemoved(oldSnapshot) {
      var stack = this.snapshotToStack(oldSnapshot);
      this.emit('removed', stack);
    }
  }, {
    key: "snapshotToStack",
    value: function snapshotToStack(snapshot) {
      var key = snapshot.key;
      var stack = snapshot.val();
      stack.key = key;
      stack.username = null;

      this.userRef.child(stack.creator + '/username').on('value', function (snapshot) {
        stack.username = snapshot.val();
      });

      return stack;
    }
  }, {
    key: "findIndex",
    value: function findIndex(stacks, key) {
      return stacks.findIndex(function (stack) {
        return stack.key === key;
      });
    }
  }, {
    key: "find",
    value: function find(stacks, key) {
      return stacks.find(function (stack) {
        return stack.key === key;
      });
    }
  }]);

  return stackFunctions;
}(__WEBPACK_IMPORTED_MODULE_5_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = new stackFunctions();

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FirebaseApp__ = __webpack_require__(8);


/* harmony default export */ __webpack_exports__["a"] = {
  providers: {
    twitter: new __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"].TwitterAuthProvider(),
    google: new __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"].GoogleAuthProvider(),
    facebook: new __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"].FacebookAuthProvider(),
    github: new __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"].GithubAuthProvider()
  },
  user: null,
  ref: __WEBPACK_IMPORTED_MODULE_0_firebase__["auth"](),
  onAuth: function onAuth(authCallback) {
    this.ref.onAuthStateChanged(authCallback);
  },
  getAuth: function getAuth() {
    return this.ref.currentUser;
  },
  loginWithPassword: function loginWithPassword(credentials) {
    return this.ref.signInWithEmailAndPassword(credentials.email, credentials.password);
  },
  signUpWithPassword: function signUpWithPassword(credentials) {
    return this.ref.createUserWithEmailAndPassword(credentials.email, credentials.password);
  },
  signInWithProvider: function signInWithProvider(providerName, callback) {
    var provider = this.providers[providerName];
    this.ref.signInWithPopup(provider).then(function (result) {
      if (callback) {
        callback(null, result);
      }
    }, function (error) {
      callback(error);
    });
  },
  signOut: function signOut() {
    this.ref.signOut();
  }
};

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(204),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FirebaseApp__ = __webpack_require__(8);











var cardRepository = function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(cardRepository, _EventEmitter);

  function cardRepository() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, cardRepository);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (cardRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(cardRepository)).call(this));

    _this.ref = __WEBPACK_IMPORTED_MODULE_8_firebase__["database"]().ref('cards');
    _this.userRef = __WEBPACK_IMPORTED_MODULE_8_firebase__["database"]().ref('users');
    _this.stackRef = __WEBPACK_IMPORTED_MODULE_8_firebase__["database"]().ref('stacks');

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(cardRepository, [{
    key: "create",
    value: function create(_ref, onComplete) {
      var type = _ref.type,
          title = _ref.title,
          author = _ref.author,
          description = _ref.description,
          url = _ref.url,
          image = _ref.image,
          _ref$snippet = _ref.snippet,
          snippet = _ref$snippet === undefined ? '' : _ref$snippet,
          icon = _ref.icon,
          show = _ref.show,
          source = _ref.source,
          creator = _ref.creator,
          stack = _ref.stack,
          order = _ref.order,
          stackCount = _ref.stackCount,
          length = _ref.length,
          boundStack = _ref.boundStack;

      var that = this;
      this.ref.push({ type: type, title: title, author: author, description: description, url: url, image: image, snippet: snippet, icon: icon, show: show, source: source, creator: creator, length: length, boundStack: boundStack }, onComplete).then(function (card) {
        that.ref.child(card.key).update({ created: __WEBPACK_IMPORTED_MODULE_8_firebase__["database"].ServerValue.TIMESTAMP }, onComplete);

        that.userRef.child(creator + '/cards/' + card.key).set(true, onComplete);

        that.userRef.child(creator + '/cardCount').transaction(function (currentCount) {
          return currentCount + 1;
        });

        if (stack) {
          that.addStack(card, stack, order);
        }

        if (boundStack) {
          that.stackRef.child(boundStack + '/boundCard').set(card.key, onComplete);
        }
      });
    }
  }, {
    key: "update",
    value: function update(_ref2, onComplete) {
      var key = _ref2.key,
          _ref2$title = _ref2.title,
          title = _ref2$title === undefined ? '' : _ref2$title,
          _ref2$description = _ref2.description,
          description = _ref2$description === undefined ? '' : _ref2$description,
          _ref2$url = _ref2.url,
          url = _ref2$url === undefined ? '' : _ref2$url,
          _ref2$image = _ref2.image,
          image = _ref2$image === undefined ? '' : _ref2$image,
          _ref2$source = _ref2.source,
          source = _ref2$source === undefined ? '' : _ref2$source,
          _ref2$snippet = _ref2.snippet,
          snippet = _ref2$snippet === undefined ? '' : _ref2$snippet,
          show = _ref2.show;

      this.ref.child(key).update({ title: title, description: description, url: url, image: image, source: source, snippet: snippet, show: show }, onComplete);
    }
  }, {
    key: "remove",
    value: function remove(card, onComplete) {

      var that = this;

      if (card.stacks) {
        var stackKeys = card.stacks;
        for (var stackKey in stackKeys) {
          this.stackRef.child(stackKey).once("value", function (snapshot) {
            var stack = snapshot.val();
            stack.key = snapshot.key;
            that.removeStack(card, stack);
          });
        }
      }

      this.ref.child(card.key).remove(onComplete);

      this.userRef.child(card.creator + '/cards/' + card.key).remove(onComplete);

      this.userRef.child(card.creator + '/cardCount').transaction(function (currentCount) {
        return currentCount - 1;
      });
    }
  }, {
    key: "addStack",
    value: function addStack(card, stack, order, onComplete) {
      this.stackRef.child(stack.key + '/cards/' + card.key).set(true, onComplete);
      this.stackRef.child(stack.key + '/cards/' + card.key).set({ order: order }, onComplete);
      this.stackRef.child(stack.key + '/cardCount').transaction(function (currentCount) {
        return currentCount + 1;
      });

      this.ref.child(card.key + '/stacks/' + stack.key).set(true, onComplete);
      this.ref.child(card.key + '/stackCount').transaction(function (currentCount) {
        return currentCount + 1;
      });

      this.ref.child(stack.boundCard + '/length').transaction(function (currentCount) {
        return currentCount + 1;
      });
    }
  }, {
    key: "removeStack",
    value: function removeStack(_ref3, stack, onComplete) {
      var key = _ref3.key;

      var that = this;

      var stackUpdatedCount;

      var stackToRemoveRef = this.stackRef.child(stack.key);

      var cardToRemoveOrder;

      this.ref.child(key + '/stacks/' + stack.key).remove(onComplete);

      this.ref.child(key + '/stackCount').transaction(function (currentCount) {
        return currentCount - 1;
      });

      stackToRemoveRef.child('/cards/' + key + '/order/').once("value", function (snapshot) {

        cardToRemoveOrder = snapshot.val();

        stackToRemoveRef.child('/cards/' + key).remove(onComplete).then(function () {
          stackToRemoveRef.child('/cards/').once("value", function (snapshot) {

            if (snapshot.val()) {

              var remainingStacks = snapshot.val();
              stackUpdatedCount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(remainingStacks).length;

              stackToRemoveRef.child('/cardCount').set(stackUpdatedCount, onComplete);

              that.ref.child(stack.boundCard + '/length').set(stackUpdatedCount, onComplete);

              snapshot.forEach(function (remainingStack) {
                var stack = remainingStack.val();
                var key = remainingStack.key;

                if (stack.order > cardToRemoveOrder) {
                  stackToRemoveRef.child('/cards/' + key + '/order/').set(stack.order - 1, onComplete);
                }
              });
            } else {
              stackToRemoveRef.child('/cardCount').set(0, onComplete);

              that.ref.child(stack.boundCard + '/length').set(0, onComplete);
            }
          });
        });
      });
    }
  }, {
    key: "removeStackfromCards",
    value: function removeStackfromCards(_ref4, cardkeys, onComplete) {
      var key = _ref4.key;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {

        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(cardkeys), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cardkey = _step.value;

          this.ref.child(cardkey + '/stacks/' + key).remove(onComplete);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "attachFirebaseListeners",
    value: function attachFirebaseListeners() {
      this.ref.on('child_added', this.onAdded, this);
      this.ref.on('child_removed', this.onRemoved, this);
      this.ref.on('child_changed', this.onChanged, this);
    }
  }, {
    key: "detachFirebaseListeners",
    value: function detachFirebaseListeners() {
      this.ref.off('child_added', this.onAdded, this);
      this.ref.off('child_removed', this.onRemoved, this);
      this.ref.off('child_changed', this.onChanged, this);
      this.stackRef.off();
      this.userRef.off();
    }
  }, {
    key: "onAdded",
    value: function onAdded(snapshot) {
      var card = this.snapshotToCard(snapshot);

      this.emit('added', card);
    }
  }, {
    key: "onRemoved",
    value: function onRemoved(oldSnapshot) {
      var card = this.snapshotToCard(oldSnapshot);
      this.emit('removed', card);
    }
  }, {
    key: "onChanged",
    value: function onChanged(snapshot) {
      var card = this.snapshotToCard(snapshot);
      this.emit('changed', card);
    }
  }, {
    key: "snapshotToCard",
    value: function snapshotToCard(snapshot) {
      var key = snapshot.key;
      var card = snapshot.val();
      card.key = key;
      card.username = null;

      this.userRef.child(card.creator + '/username').on('value', function (snapshot) {
        card.username = snapshot.val();
      });

      return card;
    }
  }, {
    key: "findIndex",
    value: function findIndex(cards, key) {
      return cards.findIndex(function (card) {
        return card.key === key;
      });
    }
  }, {
    key: "find",
    value: function find(cards, key) {
      return cards.find(function (card) {
        return card.key === key;
      });
    }
  }]);

  return cardRepository;
}(__WEBPACK_IMPORTED_MODULE_7_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = new cardRepository();

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(198),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(169)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(194),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(173)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(203),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(170)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(195),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(168)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(192),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(172)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(200),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(201),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(191),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(197),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(120),
  /* template */
  __webpack_require__(189),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'swiper-slide',
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },

  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
};

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var browser = typeof window !== 'undefined';
if (browser) {
  window.Swiper = __webpack_require__(73);
  __webpack_require__(166);
}
/* harmony default export */ __webpack_exports__["default"] = {
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    }
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function mount() {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        self.swiper = new Swiper(self.$el, self.options);
      }
    };
    this.options.notNextTick ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
};

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Auth__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_FirebaseApp__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EventBus__ = __webpack_require__(2);








/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      user: null,
      loading: true
    };
  },

  components: {
    HeaderBar: __WEBPACK_IMPORTED_MODULE_0__components_HeaderBar___default.a
  },
  methods: {
    processUser: function processUser(authed) {
      if (authed === null) {
        this.user = null;
        return;
      }

      var that = this;

      __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('/users/' + authed.uid).once('value').then(function (snapshot) {

        that.user.username = snapshot.val().username;
      });

      this.user = {
        userTitle: authed.providerData[0].displayName || authed.providerData[0].email || '',
        imageUrl: authed.providerData[0].photoURL,
        uid: authed.uid
      };
    },

    stopLoading: function stopLoading() {
      this.loading = false;
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4__components_EventBus__["a" /* default */].$on('loaded', this.stopLoading);
    __WEBPACK_IMPORTED_MODULE_1__data_Auth__["a" /* default */].onAuth(this.processUser);
    this.processUser(__WEBPACK_IMPORTED_MODULE_1__data_Auth__["a" /* default */].getAuth());
  },
  mounted: function mounted() {}
};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_Auth__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = {
  props: ['user'],
  data: function data() {
    return {
      searchQuery: ''
    };
  },

  watch: {
    'searchQuery': function searchQuery() {
      __WEBPACK_IMPORTED_MODULE_1__EventBus__["a" /* default */].$emit('search', this.searchQuery);
    }
  },
  methods: {
    signOut: function signOut() {
      __WEBPACK_IMPORTED_MODULE_0__data_Auth__["a" /* default */].signOut();
      this.$router.push('auth');
    }
  }
};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_CardRepository__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = {
	props: ['card', 'stack', 'user', 'index'],

	methods: {
		remove: function remove() {
			__WEBPACK_IMPORTED_MODULE_0__data_CardRepository__["a" /* default */].remove(this.card, function (err) {
				if (err) throw err;
			});
		},
		updateModal: function updateModal() {
			__WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* default */].$emit('card.selected', this.card);
		},
		stackModal: function stackModal() {
			__WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* default */].$emit('card.stack', this.card);
		}
	},
	mounted: function mounted() {}
};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_getMeta__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_CardRepository__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = {
    props: ['user', 'stack'],
    data: function data() {
        return {
            type: 'link',
            title: '',
            author: '',
            description: '',
            url: '',
            image: '',
            source: '',
            snippet: '',
            icon: '',
            stackKey: '',
            length: '',
            show: 'image',
            metad: false,
            showFields: false
        };
    },

    watch: {},
    mounted: function mounted() {
        var that = this;
        __WEBPACK_IMPORTED_MODULE_0__data_getMeta__["a" /* default */].on('metad', function () {
            that.metad = false;
            that.showFields = true;
        });
        __WEBPACK_IMPORTED_MODULE_0__data_getMeta__["a" /* default */].on('meta.error', function () {
            that.metad = false;
            that.showFields = true;
        });
    },

    methods: {
        fetchMeta: function fetchMeta() {
            __WEBPACK_IMPORTED_MODULE_0__data_getMeta__["a" /* default */].get(this);
            this.metad = true;
        },
        createCard: function createCard() {
            var _this = this;

            if (this.title.trim() || this.description.trim() || this.url.trim() || this.image.trim()) {
                if (this.stack) {
                    this.stackKey = this.stack.key;

                    var stackOrder;
                    var stackCount;

                    if (this.stack.cardCount) {
                        stackOrder = this.stack.cardCount + 1;
                        stackCount = this.stack.cardCount + 1;
                    } else {
                        stackOrder = 1;
                        stackCount = 1;
                    }
                }
                __WEBPACK_IMPORTED_MODULE_1__data_CardRepository__["a" /* default */].create({
                    type: this.type,
                    title: this.title,
                    author: this.author,
                    description: this.description,
                    url: this.url,
                    image: this.image,
                    source: this.source,
                    snippet: this.snippet,
                    icon: this.icon,
                    show: this.show,
                    creator: this.user.uid,
                    stack: this.stack,
                    length: this.length,
                    order: stackOrder,
                    stackCount: stackCount,
                    boundStack: null
                }, function (err) {
                    if (err) {
                        throw err;
                    }

                    _this.type = '';
                    _this.title = '';
                    _this.author = '';
                    _this.description = '';
                    _this.url = '';
                    _this.image = '';
                    _this.source = '';
                    _this.snippet = '';
                    _this.showFields = false;
                    _this.type = 'link';
                });
            }
        }
    }
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_slug__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_cardRepository__ = __webpack_require__(56);





/* harmony default export */ __webpack_exports__["default"] = {
  props: ['user'],
  data: function data() {
    return {
      title: '',
      description: ''
    };
  },
  created: function created() {},

  methods: {
    createStack: function createStack() {
      var _this = this;

      if (this.title.trim() || this.description.trim()) {
        __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].create({
          title: this.title,
          description: this.description,
          slug: __WEBPACK_IMPORTED_MODULE_0__data_slug__["a" /* default */].get(this.title),
          creator: this.user.uid
        }, function (err) {
          if (err) {
            throw err;
          }
          _this.title = '';
          _this.description = '';
          _this.slug = '';
        });
      }
    }
  }
};

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EventBus__ = __webpack_require__(2);



var _props$components$dat;





/* harmony default export */ __webpack_exports__["default"] = _props$components$dat = {
  props: ['user'],
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_2__Card___default.a
  },
  data: function data() {
    return {
      cards: [],
      searchQuery: '',
      loadCard: true
    };
  },

  computed: {
    filteredCards: function filteredCards() {
      var _this = this;

      return this.cards.filter(function (card) {
        if (_this.searchQuery) return card.title.indexOf(_this.searchQuery) !== -1 || card.description.indexOf(_this.searchQuery) !== -1;
        return true;
      });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4__components_EventBus__["a" /* default */].$on('search', this.passQuery);
  },
  methods: {
    passQuery: function passQuery(query) {
      this.searchQuery = query;
    },
    cardNumber: function cardNumber(cards) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(cards).length;
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'created', function created() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'mounted', function mounted() {
  var _this2 = this;

  __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__["a" /* default */].on('added', function (card) {
    _this2.cards.unshift(card);
    if (_this2.loadCard) {
      __WEBPACK_IMPORTED_MODULE_4__components_EventBus__["a" /* default */].$emit('loaded');
      _this2.loadCard = false;
    }
  });
  __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__["a" /* default */].on('changed', function (_ref) {
    var key = _ref.key,
        title = _ref.title,
        description = _ref.description,
        url = _ref.url,
        stacks = _ref.stacks,
        length = _ref.length;

    var outdatedCard = __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__["a" /* default */].find(_this2.cards, key);
    outdatedCard.title = title;
    outdatedCard.description = description;
    outdatedCard.url = url;
    outdatedCard.stacks = stacks;
    outdatedCard.length = length;
  });
  __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__["a" /* default */].on('removed', function (_ref2) {
    var key = _ref2.key;

    var cardToRemove = __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__["a" /* default */].findIndex(_this2.cards, key);
    _this2.cards.splice(cardToRemove, 1);
  });
  __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__["a" /* default */].attachFirebaseListeners();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_props$components$dat, 'beforeDestroy', function beforeDestroy() {
  __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__["a" /* default */].removeAllListeners();
  __WEBPACK_IMPORTED_MODULE_3__data_CardRepository__["a" /* default */].detachFirebaseListeners();
}), _props$components$dat;

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_CardRepository__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = {
	props: ['stack', 'user'],
	data: function data() {
		return {};
	},

	components: {},
	methods: {
		cardNumber: function cardNumber(cards) {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cards).length;
		},
		remove: function remove() {
			if (this.stack.cards) {
				var cardkeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.stack.cards);
				__WEBPACK_IMPORTED_MODULE_2__data_CardRepository__["a" /* default */].removeStackfromCards(this.stack, cardkeys, function (err) {
					if (err) throw err;
				});
			}

			__WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].remove(this.stack, function (err) {
				if (err) throw err;
			});
		},
		updateStackModal: function updateStackModal() {
			__WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$emit('stack.selected', this.stack);
		}
	},
	mounted: function mounted() {}
};

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_CardRepository__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus__ = __webpack_require__(2);







/* harmony default export */ __webpack_exports__["default"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  data: function data() {
    return {
      card: null,
      stack: null,
      stacks: []
    };
  },

  props: ['user'],
  computed: {},
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$on('card.stack', this.selectCard);
    __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$on('stack.addStack', this.selectStack);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$off('card.stack', this.selectCard);
    __WEBPACK_IMPORTED_MODULE_3__EventBus__["a" /* default */].$off('stack.addStack', this.selectStack);
  },
  methods: {
    addStack: function addStack(card, stack) {

      var order;

      if (stack.cards) {
        order = stack.cardCount + 1;
      } else {
        order = 1;
      }

      __WEBPACK_IMPORTED_MODULE_2__data_CardRepository__["a" /* default */].addStack(card, stack, order, function (err) {
        if (err) throw err;
      });
    },
    removeStack: function removeStack(card, stack) {

      __WEBPACK_IMPORTED_MODULE_2__data_CardRepository__["a" /* default */].removeStack(card, stack, function (err) {
        if (err) throw err;
      });
    },
    selectCard: function selectCard(card) {
      this.card = card;
    },

    selectStack: function selectStack(stack) {
      this.card = stack.boundCardObj;
      this.card.key = stack.boundCard;
    },

    update: function update() {
      this.dismissModal();
    },
    dismissModal: function dismissModal() {
      this.card = null;
    }
  },

  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].on('added', function (stack) {
      _this.stacks.unshift(stack);
    });

    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].on('changed', function (_ref) {
      var key = _ref.key,
          title = _ref.title,
          description = _ref.description,
          slug = _ref.slug,
          cards = _ref.cards,
          cardCount = _ref.cardCount;

      var outdatedStack = __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].find(_this.stacks, key);
      outdatedStack.title = title;
      outdatedStack.description = description;
      outdatedStack.slug = slug;
      outdatedStack.cards = cards;
      outdatedStack.cardCount = cardCount;
    });

    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].on('removed', function (_ref2) {
      var key = _ref2.key,
          cards = _ref2.cards;

      var stackToRemoveCard = __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].find(_this.stacks, key);
      stackToRemoveCard.cards = cards;
    });

    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].attachFirebaseListeners();
  }
}, 'beforeDestroy', function beforeDestroy() {
  __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].detachFirebaseListeners();
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_CardRepository__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      card: null
    };
  },

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__EventBus__["a" /* default */].$on('card.selected', this.selectCard);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__EventBus__["a" /* default */].$off('card.selected', this.selectCard);
  },
  methods: {
    selectCard: function selectCard(card) {
      this.card = card;
    },
    remove: function remove() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__data_CardRepository__["a" /* default */].remove(this.card, function (err) {
        if (err) throw err;
        _this.dismissModal();
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__data_CardRepository__["a" /* default */].update(this.card, function (err) {
        if (err) throw err;
        _this2.dismissModal();
      });
    },
    dismissModal: function dismissModal() {
      this.card = null;
    }
  }
};

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_stackFunctions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      stack: null
    };
  },

  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__EventBus__["a" /* default */].$on('stack.selected', this.selectStack);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__EventBus__["a" /* default */].$off('stack.selected', this.selectStack);
  },
  methods: {
    selectStack: function selectStack(stack) {
      this.stack = stack;
    },
    remove: function remove() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__data_stackFunctions__["a" /* default */].remove(this.stack, function (err) {
        if (err) throw err;
        _this.dismissModal();
      });
    },
    update: function update() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__data_stackFunctions__["a" /* default */].update(this.stack, function (err) {
        if (err) throw err;
        _this2.dismissModal();
      });
    },
    dismissModal: function dismissModal() {
      this.stack = null;
    }
  }
};

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_Auth__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EventBus__ = __webpack_require__(2);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      wantsToSignUp: true
    };
  },

  methods: {
    signUpWithPassword: function signUpWithPassword() {
      var _this = this;

      if (this.password === this.confirmPassword) {
        __WEBPACK_IMPORTED_MODULE_0__data_Auth__["a" /* default */].signUpWithPassword({
          email: this.email,
          password: this.password
        }).then(function (userData) {
          return _this.loginWithPassword();
        }).then(function () {
          return __WEBPACK_IMPORTED_MODULE_1__components_EventBus__["a" /* default */].$emit('alert', { type: 'success', message: 'Signed up successfully' });
        }).catch(function (error) {
          return __WEBPACK_IMPORTED_MODULE_1__components_EventBus__["a" /* default */].$emit('alert', { type: 'error', message: error.message });
        });
      }
    },
    loginWithPassword: function loginWithPassword() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0__data_Auth__["a" /* default */].loginWithPassword({
        email: this.email,
        password: this.password
      }).then(function (userData) {
        __WEBPACK_IMPORTED_MODULE_1__components_EventBus__["a" /* default */].$emit('alert', { type: 'success', message: 'Signed in successfully' });
        _this2.onSignedIn();
        return userData;
      }).catch(function (error) {
        return __WEBPACK_IMPORTED_MODULE_1__components_EventBus__["a" /* default */].$emit('alert', { type: 'error', message: error.message });
      });
    },
    signInWithProvider: function signInWithProvider(provider) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0__data_Auth__["a" /* default */].signInWithProvider(provider, function (error, authData) {
        if (error) {
          return __WEBPACK_IMPORTED_MODULE_1__components_EventBus__["a" /* default */].$emit('alert', { type: 'error', message: error.message });
        }
        _this3.onSignedIn();
      });
    },
    onSignedIn: function onSignedIn() {
      this.$router.push({ name: 'stacks' });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__components_EventBus__["a" /* default */].$emit('loaded');
  }
};

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cards_Index__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cards_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__cards_Index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards_Create__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cards_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cards_UpdateModal__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cards_UpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__cards_UpdateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cards_StackModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cards_StackModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cards_StackModal__);







/* harmony default export */ __webpack_exports__["default"] = {
  props: ['user'],
  components: {
    Cards: __WEBPACK_IMPORTED_MODULE_0__cards_Index___default.a,
    CreateCardForm: __WEBPACK_IMPORTED_MODULE_1__cards_Create___default.a,
    UpdateModal: __WEBPACK_IMPORTED_MODULE_2__cards_UpdateModal___default.a,
    StackModal: __WEBPACK_IMPORTED_MODULE_3__cards_StackModal___default.a
  }
};

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_userFunctions__ = __webpack_require__(123);



/* harmony default export */ __webpack_exports__["default"] = {
  props: ['user'],
  data: function data() {
    return {
      username: ''
    };
  },

  methods: {
    createUser: function createUser() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__data_userFunctions__["a" /* default */].create({
        username: this.username,
        uid: this.user.uid
      }, function (err) {
        if (err) {
          throw err;
        }
        _this.username = '';
      });
    }
  }
};

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards_Card__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cards_Card___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cards_Card__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_FirebaseApp__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_CardRepository__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_stackFunctions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards_UpdateModal__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards_UpdateModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__cards_UpdateModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cards_StackModal__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cards_StackModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__cards_StackModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__EventBus__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cards_Create__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__cards_Create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__cards_Create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__);














var database = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]();

/* harmony default export */ __webpack_exports__["default"] = {
	props: ['user'],
	data: function data() {
		return {
			cards: [],
			stack: null,
			loadStack: true,
			stackRef: null,
			stackKeyLoaded: false,
			stackCardCount: null,
			stackNumber: 0,
			swiperOption: {
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				pagination: '.swiper-pagination',
				paginationType: 'progress',
				paginationClickable: true,
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 15,
				breakpoints: {
					1024: {
						slidesPerView: 3,
						slidesPerGroup: 3
					},
					768: {
						slidesPerView: 2,
						slidesPerGroup: 2
					},
					600: {
						slidesPerView: 1,
						slidesPerGroup: 1
					}
				}
			}
		};
	},

	watch: {
		stackKeyLoaded: function stackKeyLoaded() {
			this.getCards();
			this.removeCard();
		}
	},
	components: {
		Card: __WEBPACK_IMPORTED_MODULE_1__cards_Card___default.a,
		UpdateModal: __WEBPACK_IMPORTED_MODULE_6__cards_UpdateModal___default.a,
		StackModal: __WEBPACK_IMPORTED_MODULE_7__cards_StackModal___default.a,
		CreateCardForm: __WEBPACK_IMPORTED_MODULE_9__cards_Create___default.a,
		swiper: __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__["swiper"],
		swiperSlide: __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__["swiperSlide"]
	},
	computed: {},
	created: function created() {},

	methods: {
		getCards: function getCards() {

			var that = this;

			__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('stacks/' + this.stack.key + '/cards').orderByChild("order").on('child_added', function (snapshot) {

				var cardKey = snapshot.key;
				__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('cards/' + cardKey).once('value').then(function (snapshot) {

					var card = snapshot.val();
					if (card) {
						card.key = cardKey;

						__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('users/' + card.creator + '/username').once('value').then(function (snapshot) {
							card.username = snapshot.val();
							that.cards.push(card);
							if (that.loadStack) {
								__WEBPACK_IMPORTED_MODULE_8__EventBus__["a" /* default */].$emit('loaded');
								that.loadStack = false;
							}
						});
					}
				});
			});
		},
		removeCard: function removeCard() {
			var that = this;
			__WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref('stacks/' + this.stack.key + '/cards').on('child_removed', function (snapshot) {
				var cardToRemove = __WEBPACK_IMPORTED_MODULE_4__data_CardRepository__["a" /* default */].findIndex(that.cards, snapshot.key);
				that.cards.splice(cardToRemove, 1);
			});
		},
		stackModal: function stackModal() {
			__WEBPACK_IMPORTED_MODULE_8__EventBus__["a" /* default */].$emit('stack.addStack', this.stack);
		}
	},
	mounted: function mounted() {

		this.stackRef = database.ref("stacks").orderByChild('slug').equalTo(this.$route.params.slug);
		var that = this;
		this.stackRef.on('value', function (snapshot) {
			var foundStack = snapshot.val();
			var stackkey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(foundStack);
			that.stack = foundStack[stackkey];
			that.stack.key = stackkey[0];
			that.stackKeyLoaded = true;
			that.stackCardCount = that.stack.cardCount;
			if (that.stack.cardCount == null || that.stack.cardCount == 0) {
				__WEBPACK_IMPORTED_MODULE_8__EventBus__["a" /* default */].$emit('loaded');
			}
			var userRef = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref("users/" + that.stack.creator + '/username');
			userRef.once('value').then(function (snapshot) {
				that.stack.username = snapshot.val();
			});

			var boundCardRef = __WEBPACK_IMPORTED_MODULE_2_firebase__["database"]().ref("cards/" + that.stack.boundCard);
			boundCardRef.once('value').then(function (snapshot) {
				that.stack.boundCardObj = snapshot.val();
				if (that.stack.boundCardObj.stacks) {
					that.stackNumber = that.stack.boundCardObj.stackCount;
				}
			});
		});
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_5__data_stackFunctions__["a" /* default */].detachFirebaseListeners();
		__WEBPACK_IMPORTED_MODULE_4__data_CardRepository__["a" /* default */].detachFirebaseListeners();
		this.stackRef.off();
	}
};

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_Auth__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cards_CreateStack__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cards_CreateStack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__cards_CreateStack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cards_Stack__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cards_Stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__cards_Stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cards_UpdateStackModal__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cards_UpdateStackModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__cards_UpdateStackModal__);









/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      stacks: [],
      loadStacks: true

    };
  },

  props: ['user', 'loading'],
  components: {
    CreateStackForm: __WEBPACK_IMPORTED_MODULE_3__cards_CreateStack___default.a,
    Stack: __WEBPACK_IMPORTED_MODULE_4__cards_Stack___default.a,
    UpdateStackModal: __WEBPACK_IMPORTED_MODULE_5__cards_UpdateStackModal___default.a

  },
  computed: {},
  methods: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].on('added', function (stack) {
      _this.stacks.unshift(stack);
      if (_this.loadStacks) {
        __WEBPACK_IMPORTED_MODULE_2__EventBus__["a" /* default */].$emit('loaded');
        _this.loadStacks = false;
      }
    });

    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].on('changed', function (_ref) {
      var key = _ref.key,
          title = _ref.title,
          description = _ref.description,
          slug = _ref.slug,
          cards = _ref.cards;

      var outdatedStack = __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].find(_this.stacks, key);
      outdatedStack.title = title;
      outdatedStack.description = description;
      outdatedStack.slug = slug;
      outdatedStack.cards = cards;
    });

    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].on('removed', function (_ref2) {
      var key = _ref2.key;

      var stackToRemove = __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].findIndex(_this.stacks, key);
      _this.stacks.splice(stackToRemove, 1);
    });

    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].attachFirebaseListeners();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__data_stackFunctions__["a" /* default */].detachFirebaseListeners();
  }
};

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);









var getMeta = function (_EventEmitter) {
	__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(getMeta, _EventEmitter);

	function getMeta() {
		__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, getMeta);

		return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (getMeta.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(getMeta)).call(this));
	}

	__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(getMeta, [{
		key: 'get',
		value: function get(card) {
			var that = this;

			var apikey = "28c12ec129ebac041e1cf7";

			var getUrl = "https://iframe.ly/api/iframely?url=" + card.url + "&api_key=" + apikey;

			__WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(getUrl).then(function (response) {
				var item = response.data;

				card.title = item.meta.title;

				if (item.meta.site) {
					card.source = item.meta.site;
				}
				card.snippet = item.meta.description;

				if (item.meta.author) {
					card.author = item.meta.author;
				}

				if (item.links.thumbnail.length > 0) {
					card.image = item.links.thumbnail[0].href;
				}

				if (item.links.icon.length > 0) {
					var icons = item.links.icon;
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(icons), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var icon = _step.value;

							if (icon.type == 'image/icon' || icon.type == 'image/x-icon') {
								card.icon = icon.href;
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
				}

				switch (item.meta.site.toLowerCase()) {
					case 'youtube':
						card.type = 'video';
						card.length = item.meta.duration;
						break;
					case 'ted':
						card.type = 'video';
						break;
					case 'goodreads':
						card.type = 'book';
						break;
					default:
						card.type = 'link';
				}

				that.emit('metad');
			}).catch(function (error) {
				that.emit('meta.error');
			});
		}
	}]);

	return getMeta;
}(__WEBPACK_IMPORTED_MODULE_6_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = new getMeta();

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sluggo__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sluggo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sluggo__);




var slug = function () {
	function slug() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, slug);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(slug, [{
		key: 'get',
		value: function get(title) {
			var makeSlug = __WEBPACK_IMPORTED_MODULE_2_sluggo___default()(title);
			return makeSlug;
		}
	}]);

	return slug;
}();

/* harmony default export */ __webpack_exports__["a"] = new slug();

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_events__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FirebaseApp__ = __webpack_require__(8);









var userFunctions = function (_EventEmitter) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(userFunctions, _EventEmitter);

  function userFunctions() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, userFunctions);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (userFunctions.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(userFunctions)).call(this));

    _this.ref = __WEBPACK_IMPORTED_MODULE_6_firebase__["database"]().ref('users');
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(userFunctions, [{
    key: "create",
    value: function create(_ref, onComplete) {
      var username = _ref.username,
          uid = _ref.uid;

      __WEBPACK_IMPORTED_MODULE_6_firebase__["database"]().ref('users/' + uid).set({
        username: username
      }, onComplete);
    }
  }, {
    key: "attachFirebaseListeners",
    value: function attachFirebaseListeners() {
      this.ref.on('child_added', this.onAdded, this);
      this.ref.on('child_removed', this.onRemoved, this);
      this.ref.on('child_changed', this.onChanged, this);
    }
  }, {
    key: "detachFirebaseListeners",
    value: function detachFirebaseListeners() {
      this.ref.off('child_added', this.onAdded, this);
      this.ref.off('child_removed', this.onRemoved, this);
      this.ref.off('child_changed', this.onChanged, this);
    }
  }, {
    key: "onAdded",
    value: function onAdded(snapshot) {
      var stack = this.snapshotToStack(snapshot);

      this.emit('added', stack);
    }
  }, {
    key: "snapshotToStack",
    value: function snapshotToStack(snapshot) {
      var key = snapshot.key;
      var user = snapshot.val();
      user.key = key;
      return user;
    }
  }]);

  return userFunctions;
}(__WEBPACK_IMPORTED_MODULE_5_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = new userFunctions();

/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(205),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(202),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(171)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(196),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(199),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(193),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(167)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(190),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stacks"
  }, [_c('ul', {
    ref: "stacks",
    staticClass: "stack-list"
  }, [(_vm.user) ? _c('create-stack-form', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "card stack",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'cards'
        })
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'cards'
      }
    }
  }, [_c('h2', {
    staticClass: "stack-title"
  }, [_vm._v("My cards")])])], 1), _vm._v(" "), _vm._l((_vm.stacks), function(stack) {
    return _c('stack', {
      key: stack.key,
      attrs: {
        "stack": stack,
        "user": _vm.user
      }
    })
  })], 2), _vm._v(" "), _c('update-stack-modal')], 1)
},staticRenderFns: []}

/***/ }),
/* 190 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stack) ? _c('div', {
    staticClass: "backdrop",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.dismissModal
    }
  }, [_c('form', {
    staticClass: "edit-card-form create edit-stack",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stack.title),
      expression: "stack.title"
    }],
    staticClass: "form-stack-title",
    attrs: {
      "name": "title",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.stack.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stack.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stack.description),
      expression: "stack.description"
    }],
    staticClass: "stack-why",
    attrs: {
      "name": "description",
      "placeholder": "why learn this?",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.stack.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stack.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Done")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 191 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "create",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createUser()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "name": "username",
      "placeholder": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("+")])])
},staticRenderFns: []}

/***/ }),
/* 192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('header-bar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('router-view', {
    attrs: {
      "user": _vm.user,
      "loading": _vm.loading
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-wave"
  }, [_c('div', {
    staticClass: "sk-rect sk-rect1"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-rect sk-rect2"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-rect sk-rect3"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-rect sk-rect4"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-rect sk-rect5"
  })])
}]}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "card stack",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'stack',
          params: {
            slug: _vm.stack.slug
          }
        })
      }
    }
  }, [_c('div', {
    staticClass: "stack-actions"
  }, [(_vm.user) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.remove($event)
      }
    }
  }, [_vm._v("delete")]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.updateStackModal($event)
      }
    }
  }, [_vm._v("edit")]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "stack-title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'stack',
        params: {
          slug: _vm.stack.slug
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.stack.title))])], 1), _vm._v(" "), _c('p', {
    staticClass: "stack-why"
  }, [_vm._v(_vm._s(_vm.stack.description))]), _vm._v(" "), _c('div', {
    staticClass: "stack-meta"
  }, [_c('p', [(_vm.stack.cards) ? _c('span', [_vm._v(_vm._s(_vm.cardNumber(_vm.stack.cards)))]) : _c('span', [_vm._v("0")]), _vm._v(" cards curated by " + _vm._s(_vm.stack.username))])])])
},staticRenderFns: []}

/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "create",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createCard()
      }
    }
  }, [(!_vm.showFields) ? _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "form-create-url",
    attrs: {
      "name": "url",
      "placeholder": "enter URL",
      "type": "text",
      "id": "card-url-input"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "create-url-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.fetchMeta()
      }
    }
  }, [_vm._v("Get data")]), _vm._v(" "), _c('a', {
    staticClass: "create-manual-input",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showFields = true
      }
    }
  }, [_vm._v("manual input")])]) : _vm._e(), _vm._v(" "), (_vm.metad) ? _c('p', [_vm._v("fetching data")]) : _vm._e(), _vm._v(" "), (_vm.showFields) ? _c('div', {
    staticClass: "create-card-fields"
  }, [_c('span', {
    staticClass: "card-type"
  }, [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.source))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "create-card-title",
    attrs: {
      "name": "title",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "create-pick-snippet"
  }, [_c('h5', [_vm._v("Pick a snippet")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "type": "radio",
      "value": "image"
    },
    domProps: {
      "checked": _vm._q(_vm.show, "image")
    },
    on: {
      "__c": function($event) {
        _vm.show = "image"
      }
    }
  }), _c('label', [_vm._v("image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "type": "radio",
      "value": "text"
    },
    domProps: {
      "checked": _vm._q(_vm.show, "text")
    },
    on: {
      "__c": function($event) {
        _vm.show = "text"
      }
    }
  }), _c('label', [_vm._v("text snippet")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "type": "radio",
      "value": ""
    },
    domProps: {
      "checked": _vm._q(_vm.show, "")
    },
    on: {
      "__c": function($event) {
        _vm.show = ""
      }
    }
  }), _c('label', [_vm._v("none")])]), _vm._v(" "), (_vm.show === 'image') ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show === 'text') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.snippet),
      expression: "snippet"
    }],
    staticClass: "create-text-snippet",
    attrs: {
      "name": "snippet",
      "placeholder": "text snippet",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.snippet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.snippet = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "create-card-why",
    attrs: {
      "name": "description",
      "placeholder": "why learn this?",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("+")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.card) ? _c('div', {
    staticClass: "backdrop",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.dismissModal
    }
  }, [_c('form', {
    staticClass: "edit-card-form create",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.title),
      expression: "card.title"
    }],
    staticClass: "create-card-title",
    attrs: {
      "name": "title",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.card.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.card.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "create-pick-snippet"
  }, [_c('h5', [_vm._v("Pick a snippet")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.show),
      expression: "card.show"
    }],
    attrs: {
      "type": "radio",
      "value": "image"
    },
    domProps: {
      "checked": _vm._q(_vm.card.show, "image")
    },
    on: {
      "__c": function($event) {
        _vm.card.show = "image"
      }
    }
  }), _c('label', [_vm._v("image")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.show),
      expression: "card.show"
    }],
    attrs: {
      "type": "radio",
      "value": "text"
    },
    domProps: {
      "checked": _vm._q(_vm.card.show, "text")
    },
    on: {
      "__c": function($event) {
        _vm.card.show = "text"
      }
    }
  }), _c('label', [_vm._v("text snippet")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.show),
      expression: "card.show"
    }],
    attrs: {
      "type": "radio",
      "value": ""
    },
    domProps: {
      "checked": _vm._q(_vm.card.show, "")
    },
    on: {
      "__c": function($event) {
        _vm.card.show = ""
      }
    }
  }), _c('label', [_vm._v("none")])]), _vm._v(" "), (_vm.card.show === 'image') ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.card.image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.card.show === 'text') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.snippet),
      expression: "card.snippet"
    }],
    staticClass: "create-text-snippet",
    attrs: {
      "name": "snippet",
      "placeholder": "text snippet",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.card.snippet)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.card.snippet = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.card.description),
      expression: "card.description"
    }],
    staticClass: "create-card-why",
    attrs: {
      "name": "description",
      "placeholder": "why learn this?",
      "rows": "5"
    },
    domProps: {
      "value": (_vm.card.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.card.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Done")])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_c('router-link', {
    attrs: {
      "to": {
        name: 'stacks'
      }
    }
  }, [_vm._v("stacks")])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-nav"
  }, [(_vm.user) ? _c('div', [(_vm.user.imageUrl) ? _c('img', {
    attrs: {
      "src": _vm.user.imageUrl,
      "alt": _vm.user.userTitle
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user.userTitle))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signOut($event)
      }
    }
  }, [_vm._v("\n          sign out\n        ")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "card-list"
  }, [(_vm.$breakpoints.isMobile()) ? _c('div', [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [(_vm.stack) ? _c('li', {
    staticClass: "card stack swiper-slide",
    attrs: {
      "stack": _vm.stack
    }
  }, [_c('h2', {
    staticClass: "stack-title"
  }, [_vm._v(_vm._s(_vm.stack.title))]), _vm._v(" "), _c('p', {
    staticClass: "stack-why"
  }, [_vm._v(_vm._s(_vm.stack.description))]), _vm._v(" "), _c('div', {
    staticClass: "stack-meta"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stackModal($event)
      }
    }
  }, [_vm._v("\n\t\t\tstacks (" + _vm._s(_vm.stackNumber) + ") | "), (_vm.stack.cards) ? _c('span', [_vm._v(_vm._s(_vm.stack.cardCount))]) : _c('span', [_vm._v("0")]), _vm._v(" cards curated by " + _vm._s(_vm.stack.username) + "\n\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('create-card-form', {
    staticClass: "swiper-slide",
    attrs: {
      "user": _vm.user,
      "stack": _vm.stack
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.cards), function(card, index) {
    return (_vm.stack.cards) ? _c('card', {
      key: card.key,
      staticClass: "swiper-slide",
      attrs: {
        "card": card,
        "stack": _vm.stack,
        "user": _vm.user,
        "index": index
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 2)], 1) : _c('div', [(_vm.stack) ? _c('li', {
    staticClass: "card stack",
    attrs: {
      "stack": _vm.stack
    }
  }, [_c('div', {
    staticClass: "card-actions"
  }, [(_vm.user) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stackModal($event)
      }
    }
  }, [_vm._v("edit stacks")]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "stack-title"
  }, [_vm._v(_vm._s(_vm.stack.title))]), _vm._v(" "), _c('p', {
    staticClass: "stack-why"
  }, [_vm._v(_vm._s(_vm.stack.description))]), _vm._v(" "), _c('div', {
    staticClass: "stack-meta"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stackModal($event)
      }
    }
  }, [_vm._v("\n\t\t\tstacks (" + _vm._s(_vm.stackNumber) + ") | "), (_vm.stack.cards) ? _c('span', [_vm._v(_vm._s(_vm.stack.cardCount))]) : _c('span', [_vm._v("0")]), _vm._v(" cards curated by " + _vm._s(_vm.stack.username) + "\n\t")])])])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('create-card-form', {
    attrs: {
      "user": _vm.user,
      "stack": _vm.stack
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.cards), function(card, index) {
    return (_vm.stack.cards) ? _c('card', {
      key: card.key,
      attrs: {
        "card": card,
        "stack": _vm.stack,
        "user": _vm.user,
        "index": index
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('update-modal'), _vm._v(" "), _c('stack-modal', {
    attrs: {
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 198 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "card"
  }, [(_vm.user) ? _c('div', {
    staticClass: "card-actions"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.remove($event)
      }
    }
  }, [_vm._v("\n\t\t\t\tdelete\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "card-edit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateModal
    }
  }, [_vm._v("\n\t\t\t\tedit\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "card-add-stack",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stackModal
    }
  }, [_vm._v("\n\t\t\t\tedit stacks\n\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "card-type"
  }, [_vm._v(_vm._s(_vm.card.type))]), _vm._v(" "), (_vm.card.type == 'stack') ? _c('div', {
    staticClass: "card-preview-stack"
  }, [_c('a', {
    attrs: {
      "href": _vm.card.url
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.card.title))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.card.length) + " cards by " + _vm._s(_vm.card.username))])])]) : _c('div', [_c('h5', {
    staticClass: "card-source"
  }, [_vm._v(_vm._s(_vm.card.source))]), _vm._v(" "), _c('h3', {
    staticClass: "card-title"
  }, [_c('a', {
    attrs: {
      "href": _vm.card.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.card.title))])]), _vm._v(" "), _c('div', {
    staticClass: "card-preview"
  }, [_c('a', {
    attrs: {
      "href": _vm.card.url,
      "target": "_blank"
    }
  }, [(_vm.card.show === 'image') ? _c('img', {
    staticClass: "card-image",
    attrs: {
      "src": _vm.card.image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.card.show === 'text') ? _c('blockquote', [_vm._v(_vm._s(_vm.card.snippet))]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.card.description) ? _c('p', {
    staticClass: "card-curator-note"
  }, [_c('strong', [_vm._v(_vm._s(_vm.card.username) + ":")]), _vm._v(" " + _vm._s(_vm.card.description))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "card-stacks",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.stackModal($event)
      }
    }
  }, [_vm._v("\n\t\t\tstacks \n\t\t\t"), (_vm.card.stackCount > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.card.stackCount) + ")")]) : _c('span', [_vm._v("(0)")])]), _vm._v(" "), (_vm.stack) ? _c('span', {
    staticClass: "card-count"
  }, [_vm._v(_vm._s(_vm.index + 1) + " / " + _vm._s(_vm.stack.cardCount) + " cards")]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    ref: "cards",
    staticClass: "card-list"
  }, [_c('li', {
    staticClass: "card"
  }, [_c('h2', [_vm._v(_vm._s(_vm.cardNumber(_vm.cards)) + " cards")])]), _vm._v(" "), _vm._l((_vm.filteredCards), function(card) {
    return _c('card', {
      key: card.key,
      attrs: {
        "card": card,
        "user": _vm.user
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "auth-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.wantsToSignUp ? _vm.signUpWithPassword() : _vm.loginWithPassword()
      }
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.wantsToSignUp ? 'Sign up' : 'Sign in'))]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "email",
      "id": "email",
      "placeholder": "Email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wantsToSignUp),
      expression: "wantsToSignUp"
    }]
  }, [_c('label', {
    attrs: {
      "for": "confirm-password"
    }
  }, [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    attrs: {
      "type": "password",
      "name": "confirm-password",
      "id": "confirm-password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.wantsToSignUp),
      expression: "!wantsToSignUp"
    }],
    staticClass: "clearfix btn-group"
  }, [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.wantsToSignUp = true
      }
    }
  }, [_vm._v("Sign up")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.wantsToSignUp),
      expression: "wantsToSignUp"
    }]
  }, [_c('button', {
    staticClass: "signup-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign up")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "social-providers"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signInWithProvider('twitter')
      }
    }
  }, [_vm._v("twitter")])])])
},staticRenderFns: []}

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [(_vm.user) ? _c('create-card-form', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), _c('cards', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), _c('update-modal'), _vm._v(" "), _c('stack-modal', {
    attrs: {
      "user": _vm.user
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.card) ? _c('div', {
    ref: "stacks",
    staticClass: "backdrop",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.dismissModal
    }
  }, [_c('form', {
    staticClass: "edit-card-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('h3', [_vm._v("Found in " + _vm._s(_vm.card.stackCount) + " stack(s)")]), _vm._v(" "), _vm._l((_vm.stacks), function(stack) {
    return _c('div', [(_vm.user) ? _c('div', [(stack.key != _vm.card.boundStack) ? _c('div', [_c('p', [_c('a', {
      attrs: {
        "href": 'stacks/' + stack.slug
      }
    }, [_vm._v(_vm._s(stack.title))]), _vm._v(" "), (stack.cards) ? _c('span', [(stack.cards.hasOwnProperty(_vm.card.key)) ? _c('span', [_vm._v("\n                added\n                "), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.removeStack(_vm.card, stack)
        }
      }
    }, [_vm._v("remove")])]) : _c('span', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.addStack(_vm.card, stack)
        }
      }
    }, [_vm._v("add")])])]) : _c('span', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.addStack(_vm.card, stack)
        }
      }
    }, [_vm._v("add")])])])]) : _vm._e()]) : _c('div', [(stack.cards.hasOwnProperty(_vm.card.key)) ? _c('span', [_c('p', [_c('a', {
      attrs: {
        "href": '/stack/' + stack.slug
      }
    }, [_vm._v(_vm._s(stack.title))])])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Done")])], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "create stack",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createStack()
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-stack-title",
    attrs: {
      "name": "title",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    attrs: {
      "name": "description",
      "placeholder": "Describe the purpose of this stack",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("add")])])
},staticRenderFns: []}

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-slide"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 206 */,
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Cards__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Cards___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_Cards__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Auth__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_Auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cards_CreateStack__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_cards_CreateStack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_cards_CreateStack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Stacks__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Stacks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_Stacks__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Stack__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_Stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Register__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_simple_breakpoints__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_simple_breakpoints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_simple_breakpoints__);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_simple_breakpoints___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ name: 'cards', path: '/cards', component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Cards___default.a }, { name: 'auth', path: '/auth', component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Auth___default.a }, { name: 'create stack', path: '/stacks/create', component: __WEBPACK_IMPORTED_MODULE_5__components_cards_CreateStack___default.a }, { name: 'stacks', path: '/', component: __WEBPACK_IMPORTED_MODULE_6__components_pages_Stacks___default.a }, { name: 'stack', path: '/stack/:slug', component: __WEBPACK_IMPORTED_MODULE_7__components_pages_Stack___default.a }, { name: 'register', path: '/register', component: __WEBPACK_IMPORTED_MODULE_8__components_pages_Register___default.a }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a },
  router: router
});

/***/ })
],[207]);


// WEBPACK FOOTER //
// static/js/app.523cc8f0bde38cb6f92b.js